<template>
  <div id="top">
    <ClientOnly>
      <LazyEmployeeToolbar
        v-if="isIntegrationEnabled('cognito') && $cognito.isLoggedIn() && $cognito.isSalesEmployee()"
      />
    </ClientOnly>
    <HeaderPromoBar />
    <HeaderLinkBar />
    <Header />
    <slot />
    <Footer />
  </div>
</template>

<script setup lang="ts">
const { $cognito } = useNuxtApp()
const { isIntegrationEnabled } = useUtils()
</script>
